(function () {

    'use strict';

    angular.module('FotocApp')

    .component('simpleLayoutSelector', { 
        templateUrl: (USE_TEMPLATE_CACHE ? '' :  window.BASE_PATH  + '../../src/') + 'editor/simpleLayoutSelector.component.html',
        bindings: {},
        controller: ['$scope', '$editorService','$canvasService', '$lang', function ($scope, $editorService, $canvasService, $lang) {
       
            this.$canvasService = $canvasService;
            this.$editorService = $editorService;
            
            $scope.$lang = $lang;

            this.setLayout = function ($layout_key){
            $editorService.ui.view = {type:'edit'};
            $editorService.setLayout($layout_key)
            }
        }]
               
    })

})();